import React from 'react';
import { Mouvement } from '@mairistem/comptabilite';
import InventaireComponent from '../../../components/Mouvement/Panel/InventaireComponent';
import CODE_PANEL from '../../../constants/mouvements/codePanel';
import LignePanel from './LignePanel';

class InventairePanel extends LignePanel {
  constructor(isMandatory = false) {
    super(isMandatory);
    this.code = CODE_PANEL.INVENTAIRE;
    this.defaultSize = 6;
    this.icon = { name: 'car' };
  }

  getLibelle = () => 'Inventaire';

  isEmpty = (data: Mouvement) => !data?.lignes?.find((ligne) => ligne?.actif);

  getComponent = function getComponent(
    data: any,
    onChange: any,
    handlePin: any,
  ): React.ReactElement {
    return (
      <InventaireComponent
        data={data}
        handlePin={handlePin}
        onChange={onChange}
        panel={this}
      />
    );
  };
}

export default InventairePanel;
